<template>
  <div
    class="inline-commitment-status"
    @click="showPopover = !showPopover"
    @mouseover="performanceRenderPopover = true">
    <span v-if="commitmentMeta.active">
      <strong style="color: var(--green)">active</strong>
    </span>
    <span v-else>
      <strong style="color: var(--red)">inactive</strong>
    </span>
    <font-awesome-icon icon="caret-down" class="inline-icon" />
    <template v-if="performanceRenderPopover">
      <el-popover placement="bottom" trigger="manual" width="280" v-model="showPopover">
        <div class="my-2">Do you want to pause this commitment?</div>
        <el-radio-group v-model="commitment_active">
          <el-radio :label="true" border class="ml-0">Active</el-radio>
          <el-radio :label="false" border class="ml-0">Inactive / Paused</el-radio>
        </el-radio-group>
        <span slot="reference" style="position: relative; left: -10px;"/>
      </el-popover>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    commitmentMeta: { required: true }
  },
  data() {
    return {
      performanceRenderPopover: false, // speeds up rendering
      showPopover: false,
    };
  },
  computed: {
    commitment_active: {
      get() {
        return this.commitmentMeta.active;
      },
      set(value) {
        this.commitmentMeta.update({ active: value });
        this.showPopover = false;
      },
    },
  },
}
</script>

<style>
.inline-commitment-status:hover {
  text-decoration: underline;
  cursor: pointer;
}
</style>
